import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { dark } = theme.palette.secondary;

  return {
    addRiskButton: {
      alignSelf: "start",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      color: dark,
      fontSize: 14,
      textTransform: "capitalize",
      "& $icon": {
        fontSize: 22
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        "& .MuiButton-endIcon": {
          marginLeft: 4
        },
        "& $icon": {
          fontSize: 20
        }
      },
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        fontSize: 13,
        paddingLeft: 3,
        paddingRight: 3
      }
    },
    icon: {}
  };
});
